import { render, staticRenderFns } from "./NewShopNoOA.vue?vue&type=template&id=29a3345a&scoped=true&"
import script from "./NewShopNoOA.vue?vue&type=script&lang=js&"
export * from "./NewShopNoOA.vue?vue&type=script&lang=js&"
import style0 from "./NewShopNoOA.vue?vue&type=style&index=0&id=29a3345a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a3345a",
  null
  
)

export default component.exports